<template>
    <!-- <pagebreadcrumb :title="title" :text="text" :text1="text1" /> -->
    <div class="banner">
        <div class="text-white" style="width:420px;z-index: 5;text-align:center;position:absolute;left: 50%;margin-left:-210px;top:70px;">
            <h2 class="text-white" style="font-size:50px">Detalle Oferta</h2>
            <h4 class="text-white" style="font-size:20px"><router-link to="/" class="text-white">Inicio</router-link> / Detalle Oferta</h4>
        </div>
    </div>
  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>
    
    <!-- Page Content -->
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col-lg-9 col-md-12">
                    <div class="company-detail-block pt-0">
                        <div class="company-detail">
                            <div class="company-detail-image">
                                <img src="@/assets/img/agv_logo.jpg" class="img-fluid" alt="logo">
                            </div>
                            <div class="company-title">
                                <!-- <p>Soft Technologies</p> -->
                                <h4>{{ jobOfferDetails.work_pos }}</h4>
                            </div>
                        </div>
                        <div class="company-address">
                            <ul>
                                <li>
                                    <i class="feather-map-pin"></i>{{jobOfferDetails.place}}
                                </li>
                                <li>
                                    <i class="feather-calendar"></i>{{jobOfferDetails.end_date}}
                                </li>
                            </ul>
                        </div>
                        <div class="project-proposal-detail">
                            <ul>
                                <li>
                                    <div class="proposal-detail-img">
                                        <img src="@/assets/img/icon/computer-line.svg" alt="icons">
                                    </div>
                                    <div class="proposal-detail text-capitalize">
                                        <span class=" d-block">Tipo</span>
                                        <p class="mb-0">{{typeOffer}}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="proposal-detail-img">
                                        <img src="@/assets/img/icon/user-heart-line.svg" alt="icons">
                                    </div>
                                    <div class="proposal-detail text-capitalize">
                                        <span class="d-block">Modalidad</span>
                                        <p class="mb-0">{{typeOffer}}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="proposal-detail-img">
                                        <img src="@/assets/img/icon/user-heart-line.svg" alt="icons">
                                    </div>
                                    <div class="proposal-detail text-capitalize">
                                        <span class="d-block">Contrato</span>
                                        <p class="mb-0">{{contractOffer}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="company-detail-block company-description">
                        <h4 class="company-detail-title">Descripcion</h4>
                        <div v-html="description"></div>
                        
                        <h4 class="company-detail-title">Funciones</h4>
                        <div v-html="functions"></div>

                        <h4 class="company-detail-title">Requisitos</h4>
                        <div v-html="requirements"></div>
                        
                    </div>
                </div>
            
                <projectdeatailsidebar></projectdeatailsidebar>
            </div>
        </div>
    </div>		
    <!-- /Page Content -->
<!--    <projectdetails></projectdetails>-->

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
// import Quill from 'quill';
// import 'quill/dist/quill.snow.css'; // Importa el estilo por defecto de Quill
export default {
  data() {
    return {
      title: "Project Details",
      text: "Home",
      text1: "Projects",

      id_joboffer: null,
      jobOfferDetails: [],

      description: null,
      functions: null,
      requirements: null,
      typeOffer: "",
      modeOffer: "",
      contractOffer: "",
      dialogLoading: false,
    };
  },
  mounted(){
    // this.initQuillEditors(); // Inicializa los editores
    this.getJobOffers();
    this.id_joboffer = this.$route.query.id;
  },
  methods: {

    async getJobOffers(){
        const yo = this
        const config = {
            method: 'get',
            url: '/talentoagv/readJobOffers/',
        }
        yo.dialogLoading = true;

        await axiosIns(config)
            .then(function (response) {
                console.log(response.data['result'])
                if (response.data['is_error'] === false){
                    let resultado = response.data['result']
                    for(let r of resultado){
                        if(r['id'] == yo.id_joboffer){
                            yo.jobOfferDetails = r;
                            yo.description = r['description']; 
                            yo.functions = r['functions']
                            yo.requirements = r['requirements']
                            yo.typeOffer = "TIEMPO "+r['working_day']
                            yo.modeOffer = r['work_modality']
                            yo.contractOffer = r['type_contract']
                        }
                    }
                    
                }
            })
            .catch(function (error) {
                console.log(error);
                yo.$toastr.error(response.data['message'], 'Error')
            })
            .finally(function (){
              yo.dialogLoading = false;
            })
    },
  }
};
</script>
<style>
    .banner{
        width: 100%;
        height: 400px;
        background-image: url('../../../../assets/img/fondo_principal_inicio.png');
        background-size: contain;
        background-position: center bottom;
    }

    .banner::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 400px;
        background-color: rgba(0, 0, 0, 0.4); /* Color negro semi-transparente */
    }

    .titulo{
        position: absolute;
        top:200px;
        left: 50%;
        margin-left: -220px;
        z-index: 5;
    }
</style>
